const handleModShopRedirect = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('return-from-customizer') === 'true') {
      window.showModal(
        "<p style='padding: 60px;'><strong>Sorry</strong>, Mod Shop is not currently available in your country.</p>"
      );
    }
  };

  window.onload = () => {
    handleModShopRedirect();
  };